import React from "react"
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData, toggleHttps } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import ImageCoverPage from './ImageCoverPage';
const CoverPage = (props) => {
  const { name, title, type, reportData, reportItem, searchTags, summarizeGeographies, priorYearPeriodName, currentPeriodName, customDate, color , AiResponse, formValues, defaultLogo, user, dateDisplay} = props;
  if(!formValues) return null;
  if(formValues && formValues.cover && formValues.cover=='hide') return null;
  if(formValues && formValues.cover && formValues.cover=='image') return <ImageCoverPage {...props} />;
  return (
	<div className="report-container page-section cover-page no-header">
	    <section className="report-section">
			<div className="cover-logo">
			  {formValues &&
			  formValues.branding &&
			  formValues.branding === "mylogo" &&
			  user &&
			  user.logo ? (
				<img className="header-logo" src={user.logo} />
			  ) : formValues &&
				formValues.branding &&
				formValues.branding === "marketproof" ? (
				<img
				  className="header-logo"
				  src={defaultLogo}
				/>
			  ) : null}
			</div>
	
	          <h1 className="cover-title editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}<br/> {title || reportItem.name}</h1>
			  <hr/>
			  <div>
              {dateDisplay ? 
                <div className="cover-date editable">{dateDisplay}</div>
                :
				<div className="cover-date editable">{priorYearPeriodName} vs. {currentPeriodName}</div>
              }
			  </div>
			  <div className="cover-website">
				{formValues &&
				formValues.contact &&
				formValues.contact === "show" &&
				user &&
				user.website ? (
				  <a href={toggleHttps(user.website, true)} target="_blank">{toggleHttps(user.website, false)}</a>
				)  : null}
			  </div>
		</section>
	</div>
  );
};

export default CoverPage;